import { walletQrisUsecaseProvider } from '../usecase/usecase.provider';

export const walletQrisModuleProvider = [...walletQrisUsecaseProvider];
